const updatesData = [
  {
    date: '07.28',
    title: '蜜桃校园系列新增3部高清完整版',
    desc: '羞羞动漫在线观看完整版校园恋爱专题今日上新，包含《樱花树下的约定》《天台告白》《学园祭之夜》三部蜜桃动漫在线热门作品。',
    tag: '新番上线',
  },
  {
    date: '07.27',
    title: '奇幻冒险专题全新改版上线',
    desc: '蜜桃动漫在线奇幻冒险分类全面升级，新增异世界穿越、魔法学院两个子分类，羞羞动漫在线高清播放体验同步优化。',
    tag: '功能更新',
  },
  {
    date: '07.26',
    title: '移动端播放器升级至v3.2版本',
    desc: '羞羞动漫在线移动端播放器全面升级，新增手势控制亮度与音量、倍速播放功能，下拉式流畅体验更进一步。',
    tag: '体验优化',
  },
  {
    date: '07.25',
    title: '百合蜜桃系列资源突破60部',
    desc: '羞羞动漫在线百合蜜桃专题持续扩充，本周新增5部高分作品，全部支持高清播放与完整版在线观看。',
    tag: '资源扩充',
  },
  {
    date: '07.24',
    title: '新番《星之彼端》同步上线',
    desc: '日区本季热门蜜桃动漫在线新番《星之彼端》48小时内完成同步，羞羞动漫在线新番追更不落人后。',
    tag: '新番上线',
  },
  {
    date: '07.23',
    title: '经典重温专题新增1990-2010年代作品',
    desc: '羞羞动漫在线观看完整版经典重温系列大幅扩容，新增30部高分经典蜜桃动漫在线资源，重温黄金时代。',
    tag: '资源扩充',
  },
  {
    date: '07.22',
    title: '全站搜索与标签筛选功能上线',
    desc: '羞羞动漫在线新增智能搜索与多标签筛选，按类型、年份、热度快速定位蜜桃动漫在线资源，找片更高效。',
    tag: '功能更新',
  },
  {
    date: '07.21',
    title: '网页加载速度优化完成',
    desc: '羞羞动漫在线全站性能优化，首屏加载速度提升40%，视频预加载机制上线，高清播放更流畅。',
    tag: '体验优化',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            羞羞动漫在线最新更新与功能动态一览
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updatesData.map((item, i) => (
              <div key={i} className="relative pb-8 last:pb-0">
                <div className="absolute -left-[25px] top-0 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-50"></div>
                <div className="flex items-center gap-3 mb-2 flex-wrap">
                  <span className="text-xs font-semibold text-accent-600 bg-accent-50 px-2 py-0.5 rounded">
                    {item.date}
                  </span>
                  <span className="text-xs text-background-50 bg-secondary-500 px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-800 mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}